import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 出入金約定與其他財力證明 ViewData
 */
const ProofDocUploadViewData = [
    'POST',
    RouteUrlList.API_ProofDocUploadViewData.path,
    {},
    200,
    {
        status: true,
        title: '資料載入成功',
        message: '取得成功',
        errorCode: '',
        imageMaxSize: 5242880,
        branch: '884M 數位分公司',
        // 台幣入金 固定1筆
        depositNTDAccount: {
            bank: '玉山銀行',
            branch: '民權',
            number: '1234567890123456',
            fileNo: '81606B29-503F-4E6C-9EB2-0C6A72E3983B',
            type: 'depositNTDAccount', // 類型
            index: 0 // 編號
        },
        // 外幣出入金 固定1筆
        depositForeignAccount: {
            coin: {
                twd: false,
                usd: true,
                cny: true,
                jpy: true
            }, //幣別
            bank: '玉山銀行', //銀行
            branch: '民權', //分行
            number: '0598441000000', //帳號
            fileNo: '81606B29-503F-4E6C-9EB2-0C6A72E3983B', //存摺圖片編號
            type: 'depositNTDAccount', // 類型
            index: 0 // 編號
        },

        // 外幣入金/ 台幣入金至多2筆(不含已固定)
        // 外幣入金 + 台幣入金（若未勾外幣出金則清空、勾選後最多手動新增 2 筆）
        hasForeignWithdrawal: true,
        withdrawalForeignAccounts: [
            // 台幣入金2
            {
                // twd: 0 ; usd: 1 ; cny: 2 ; jpy: 3
                coin: {
                    twd: true,
                    usd: false,
                    cny: false,
                    jpy: false
                },
                bank: '玉山',
                branch: '台中',
                number: '0288979000000',
                fileNo: '81606B29-503F-4E6C-9EB2-0C6A72E3983B',
                type: 'withdrawalForeignAccounts', // 類型
                index: 0 // 編號
            },
            // 台幣入金3
            {
                // twd: 0 ; usd: 1 ; cny: 2 ; jpy: 3
                coin: {
                    twd: true,
                    usd: false,
                    cny: false,
                    jpy: false
                },
                bank: '玉山',
                branch: '大安',
                number: '0967979000000',
                fileNo: '81606B29-503F-4E6C-9EB2-0C6A72E3983B',
                type: 'withdrawalForeignAccounts', // 類型
                index: 0 // 編號
            },
            // 外幣幣入金1
            {
                // twd: 0 ; usd: 1 ; cny: 2 ; jpy: 3
                coin: {
                    twd: false,
                    usd: true,
                    cny: true,
                    jpy: true
                },
                bank: '玉山',
                branch: '民權',
                number: '0598441000000',
                fileNo: '81606B29-503F-4E6C-9EB2-0C6A72E3983B',
                type: 'withdrawalForeignAccounts', // 類型
                index: 0 // 編號
            },
            // 外幣幣入金2
            {
                // twd: 0 ; usd: 1 ; cny: 2 ; jpy: 3
                coin: {
                    twd: false,
                    usd: true,
                    cny: true,
                    jpy: true
                },
                bank: '玉山',
                branch: '台中',
                number: '0288441000000',
                fileNo: '81606B29-503F-4E6C-9EB2-0C6A72E3983B',
                type: 'withdrawalForeignAccounts', // 類型
                index: 0 // 編號
            },
            // 外幣幣入金3
            {
                // twd: 0 ; usd: 1 ; cny: 2 ; jpy: 3
                coin: {
                    twd: false,
                    usd: true,
                    cny: true,
                    jpy: true
                },
                bank: '玉山',
                branch: '大安',
                number: '0967441000000',
                fileNo: '81606B29-503F-4E6C-9EB2-0C6A72E3983B',
                type: 'withdrawalForeignAccounts', // 類型
                index: 0 // 編號
            }
        ],

        fileNoPassportOrCreditCard: 'filePass001',
        financeFileList: [
            {
                index: 0,
                isUploading: false,
                fileNo: 'fileFinance001'
            },
            {
                index: 1,
                isUploading: false,
                fileNo: null
            }
        ]
    }
];
export default ProofDocUploadViewData;
